import styled, { css, keyframes } from "styled-components"
import { Link as DefaultLink } from "../link/link"

const CloseAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateX(100%);
    width: 0;
  }
  to {
    opacity: 1;
    transform: translateX(0);
    width: 100%;
  }
`

const OpenAnimation = keyframes`
  from {
    display: flex;
    opacity: 1;
    transform: translateX(0);
    width: 100%;
  }
  to {
    display: none;
    opacity: 0;
    transform: translateX(100%);
    width: 0;
  }
`

const OpenMenu = css`
  animation: ${CloseAnimation} 500ms ease-in-out forwards;
  `

const CloseMenu = css`
  animation: ${OpenAnimation} 500ms ease-in-out forwards;
`

export const Container = styled.div`
  align-items: center;
  background-color: #FFFFFF;
  display: flex;
  gap: 32px;
  justify-content: center;
  padding: 18px 62px;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 2;

  @media (max-width: 768px) {
    justify-content: space-between;
    padding: 16px 32px;
  }
`

export const LogoRegion = styled.div`
  display: flex;
  gap: 24px;
`

export const Logo = styled.img``

export const Divider = styled.div`
  border-right: 1px solid #00A687;
`

export const Menu = styled.nav<{ $open: boolean }>`
  align-items: center;
  display: flex;
  flex: 1 100%;
  gap: 32px;
  justify-content: center;
  transition: all 500ms ease-in-out;

  li {
    list-style: none;

    a {
      color: #00A687;
      font-family: Ubuntu;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      text-align: left;
    }
  }

  @media (max-width: 768px) {
    align-items: flex-start;
    background-color: #FFFFFF;
    flex-direction: column;
    height: min-content;
    padding: 16px 32px;
    position: absolute;
    right: 0;
    top: 100%;

    a {
      white-space: nowrap;
    }

    ${({ $open }) => $open ? OpenMenu : CloseMenu}
  }
`

export const ButtonContainer = styled.div`
  flex: 0;

  @media (max-width: 768px) {
    a {
      display: none;
    }
  }
`

export const Link = styled(DefaultLink)`
  @media (max-width: 768px) {
    display: none;
  }
`
